import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import CorporateReportDataGrid from 'components/reports/corporate/CorporateReportDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import {
  dateFormat,
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
} from 'constant/Helpers';
// actions
import {
  setCustomerList,
  setSalesOfficerList,
  setCorporateReport,
} from 'store/corporate/CorporateActions';
// selectors
import {
  getCustomerList,
  getSalesOfficerList,
  getCorporateReport,
} from 'store/corporate/CorporateSelectors';

const CorporateReportPage = () => {
  const corporateData = useSelector((state) => getCorporateReport({ state }));
  const [inputValues, setInputValues] = useState({
    fromDate: dateFormat(new Date()),
    toDate: dateFormat(new Date()),
    dateType: 0,
    userId: -1,
    salesofficer: -1,
  });
  const customerList = useSelector((state) => getCustomerList({ state }));
  const salesOfficerList = useSelector((state) => getSalesOfficerList({ state }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setCorporateReport(params));
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
      setInputValues(queryObj);
    } else {
      fetchData(inputValues);
    }
    dispatch(setCustomerList());
    dispatch(setSalesOfficerList());
  }, []);

  const handleSubmit = async () => {
    const queryString = convertObjectIntoQueryParams(inputValues);

    navigate({
      pathname: '/report/corporate',
      search: queryString,
    });
    fetchData(inputValues);
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        title="Corporate Report"
        defaultDate
        productType
        customer
        customerList={customerList}
        salesOfficerList={salesOfficerList}
        salesOfficer
      />
      <CorporateReportDataGrid data={corporateData} type={'corporate'} />
    </div>
  );
};

export default CorporateReportPage;
